import type { Variant } from '@mui/material/styles/createTypography';
import { Stack } from '@src/common/components/Stack';
import { Typography } from '@src/common/components/Typography';
import { css } from '@src/common/styles/Styles';
import type { ReactNode } from 'react';
import { useId } from 'react';

export const DetailsItem = (props: {
  itemName: string;
  value: string | ReactNode | undefined;
  valueEmphasis?: boolean;
  labelVariant?: Variant;
}) => {
  const id = useId();
  const itemId = `item-entry-${id}`;
  return (
    <Stack className={fullWidth} aria-labelledby={itemId} direction="row">
      <Typography
        id={itemId}
        variant={props.labelVariant ?? 'body1'}
        style={{ fontWeight: 500 }}
      >
        {props.itemName}:&nbsp;
      </Typography>
      <Typography
        style={{ fontWeight: props.valueEmphasis ? 500 : '' }}
        variant="body1"
      >
        {props.value ?? '-'}
      </Typography>
    </Stack>
  );
};

const fullWidth = css({
  flex: 1,
  maxHeight: 'fit-content',
});
